import alt from '../alt'
import { loginAdmin, validateUserCode } from '../sources/AuthSources'
import { errorMessages } from '../Utils/ErrorMessages'

class AuthActions {
  validateCode (id, code) {
    return dispatch => {
      dispatch()
      validateUserCode(id, code)
        .then(response => {
          return this.loginSuccess(response.data)
        })
        .catch(error => {
          if (error.response.status === 403) {
            return this.loginFailed(error.response.data)
          } else {
            return this.loginFailed(errorMessages.general)
          }
        })
    }
  }

  storeToken (data) {
    return data
  }

  logout () {
    return true
  }

  loginSuccess (data) {
    return data
  }

  loginFailed (errorMessage) {
    return errorMessage
  }

  loginAdmin (email, password) {
    return dispatch => {
      dispatch()
      loginAdmin(email, password)
        .then(response => {
          return this.loginAdminSuccess(response.data)
        })
        .catch(error => {
          if (error.response.status === 403) {
            return this.loginFailed(errorMessages.emailOrPassWrong)
          } else {
            return this.loginFailed(errorMessages.general)
          }
        })
    }
  }

  loginAdminSuccess (data) {
    return data
  }

  logoutAdmin () {
    return true
  }

  updateToken (token) {
    return token
  }

  cleanError () {
    return true
  }
}

module.exports = alt.createActions(AuthActions)



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js